import styled from 'styled-components';
import gettext from '@sdk/lang/gettext';
import Row from '@sdk/components/ui/spacing/Row';
import { SetupOrgOnboardingSteps } from '@sdk/authentication/types';
import Column from '@sdk/components/ui/spacing/Column';

import { NumberedStepIndicator } from '@web/onboarding/steps/components/NumberedStepIndicator';
import BuildingIcon from '@web/assets/svg/UI/building.svg';
import PuzzleIcon from '@web/assets/svg/UI/puzzle.svg';
import PeopleIcon from '@web/assets/svg/UI/people.svg';

const Container = styled(Column)`
  padding-top: 40px;
  padding-bottom: 40px;
  flex-grow: 1;
  background-color: ${(props): string => props.theme.colors.bodyBg};
`;

const FlexColumn = styled(Column)`
  flex-grow: 1;
`;

type Props = {
  activeStep: SetupOrgOnboardingSteps;
  steps: SetupOrgOnboardingSteps[];
};

const STEPS_CONFIG = [
  {
    name: SetupOrgOnboardingSteps.account,
    order: 1,
    label: gettext('Set up account'),
    icon: BuildingIcon,
  },
  {
    name: SetupOrgOnboardingSteps.positions,
    order: 2,
    label: gettext('Add positions'),
    icon: PuzzleIcon,
  },
  {
    name: SetupOrgOnboardingSteps.employees,
    order: 3,
    label: gettext('Add employees'),
    icon: PeopleIcon,
  },
];

export const NumberedSteps = ({ activeStep, steps = [] }: Props) => {
  const displaySteps = STEPS_CONFIG.filter((step) => steps.includes(step.name));
  const hideStepNumber = displaySteps.length < 2;
  return (
    <Container>
      <Row>
        <FlexColumn />
        <FlexColumn>
          {displaySteps.map((step, i) => (
            <NumberedStepIndicator
              key={step.name}
              step={step}
              isActive={activeStep === step.name}
              number={i + 1}
              hideStepNumber={hideStepNumber}
            />
          ))}
        </FlexColumn>
      </Row>
    </Container>
  );
};
